@use 'shared/styles/generated/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: $space-medium-xs;
}

.headerRow {
  position: relative;
}

.titleColumn {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: $space-small-m;
}

// Макет отсчитывает маскота от рамки экрана (`right:-40, top:-14`), а наш контейнер уже
// внутри паддингов Screen.Content — поэтому паддинги вычитаем, иначе собака съезжает
// вправо-вниз и накрывает подзаголовок.
.mascot {
  position: absolute;
  right: calc(-40px - #{$screen-padding-x});
  top: calc(-14px - #{$screen-padding-top});
}
